import { render, staticRenderFns } from "./InvoiceCardComponent.vue?vue&type=template&id=2442b97a"
import script from "./InvoiceCardComponent.vue?vue&type=script&lang=js"
export * from "./InvoiceCardComponent.vue?vue&type=script&lang=js"
import style0 from "./InvoiceCardComponent.vue?vue&type=style&index=0&id=2442b97a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports